import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\oneWaterX\\modelio-flow-project\\modelio-flow-web\\src\\components\\client-auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\oneWaterX\\modelio-flow-project\\modelio-flow-web\\src\\components\\client-swr-provider.tsx");
;
import(/* webpackMode: "eager" */ "E:\\oneWaterX\\modelio-flow-project\\modelio-flow-web\\src\\styles\\globals.css");
